export const initialState = {
    municipalities: [],
    municipality: {},
};
